export default __webpack_public_path__ + "static/media/di4.4dbf20c5.jpg";